import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { DEFAULT_LOCALE } from '@constants';
import { Selector } from '@versumstudios/ui';

import * as Styles from './styles';

export function SelectorLanguage() {
  const router = useRouter();
  const [defaultValue, setDefaultValue] = useState(router.locale);

  const handleChangeLanguage = (nextLocale: string) => {
    router.push(router.route, router.asPath, { locale: nextLocale });
  };

  useEffect(() => {
    setDefaultValue(router.locale);
  }, [router.locale]);

  const list = [
    { value: router.defaultLocale || DEFAULT_LOCALE, label: 'English' },
    { value: 'de', label: 'Deutsch' },
    { value: 'xx', label: 'Test' },
  ];

  return (
    <Styles.Container>
      <Selector value={defaultValue} list={list} onChange={handleChangeLanguage} variant="basic" />
    </Styles.Container>
  );
}
